import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import useConstructor from '../../hooks/useConstructor';
import Advertisment from '.';
import useScroll from '../../hooks/useScroll';

const pathRegex = /^\/(([^/])+\/){0,3}/;
const adUnitBase = '32881787/ondacero.es';
const STICKY_DISABLE_TIMEOUT = 5000;

const AdvertismentWidget = props => {
  const { sizesd, sizesm, sizest, position, id, stickyd } = props;
  const [posi, setPosi] = useState('');
  const [adUnitSub, setAdUnitSub] = useState('');
  const [stickyTop, setStickyTop] = useState(false);
  const containerRef = useRef();

  const refs = useRef({
    header: document.querySelector('header.menuHeader'),
    modSticky: document.querySelector('.mod-sticky'),
    timeout: null,
    stickyTopActive: true
  });

  const { header, modSticky } = refs.current;

  const handleScroll = useRef(({ dir }) => {
    const container = containerRef.current;
    if (container) {
      const { top } = container.getBoundingClientRect();
      const { bottom } = header.getBoundingClientRect();

      const { timeout, stickyTopActive } = refs.current;

      if (top <= bottom && dir === 'down' && stickyTopActive) {
        setStickyTop(sticky => {
          if (!sticky) {
            if (timeout) {
              clearTimeout(timeout);
            }
            refs.current.timeout = setTimeout(() => {
              setStickyTop(false);
              refs.current.stickyTopActive = false;
            }, STICKY_DISABLE_TIMEOUT);
          }

          return true;
        });
      } else if (top > 0) {
        if (timeout) {
          clearTimeout(timeout);
        }
        setStickyTop(false);
      }
    }
  }).current;

  useScroll({
    onScroll:
      position === 'top' // publi top
        ? handleScroll
        : undefined
  });

  const controlKeys = useCallback(
    elements => {
      const IDsequals = [];
      const ArrayIds = elements.map(ad => ad.id);
      const ArrayIndex = ArrayIds.indexOf(id);
      for (let x = 0; x <= ArrayIndex; x += 1) {
        if (elements[x].getAttribute('data-position') === position) {
          IDsequals.push(ArrayIds[x]);
        }
      }
      setPosi(`${position}${IDsequals.length}`);
    },
    [position, id]
  );

  const controlAdUnit = useCallback(() => {
    const path = window.location.pathname;
    const match = path.match(pathRegex)[0];

    if (match === '/') {
      return '/home';
    }

    return match.endsWith('/') ? match.slice(0, -1) : match;
  }, []);

  const controlDevice = useCallback(
    w => {
      if (w) {
        if (w >= 1024 && sizesd) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizesd]'
              )
            )
          );
          return sizesd;
        }
        if (w <= 767 && sizesm) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizesm]'
              )
            )
          );
          return sizesm;
        }
        if (w >= 768 && w <= 1023 && sizest) {
          controlKeys(
            Array.from(
              document.querySelectorAll(
                'atres-widget[data-type=ads][data-sizest]'
              )
            )
          );
          return sizest;
        }
      }
      return null;
    },
    [controlKeys, sizesd, sizest, sizesm]
  );

  const [sizes, setSizes] = useState();

  useConstructor(() => {
    setSizes(
      controlDevice(window.innerWidth)
        ? controlDevice(window.innerWidth)
            .split(',')
            .map(size =>
              size
                .split('x')
                .map(dimension =>
                  dimension.includes('fluid')
                    ? dimension
                    : parseInt(dimension, 10)
                )
            )
        : null
    );
    setAdUnitSub(controlAdUnit());

    if (stickyd && modSticky) {
      modSticky.classList.add('mod-sticky--active');
    }
  });

  return (
    <>
      {sizes && (
        <div
          ref={containerRef}
          className={`addContainer ${stickyd && 'addContainer--sticky'}`}
        >
          <div
            data-stickyd="true"
            className={`${stickyTop ? 'addContainer--top-sticky' : ''}`}
          >
            <p className="add-tag">
              <span className="add-tag-txt">Publicidad</span>
            </p>
            {!props.static ? (
              <Advertisment
                adUnit={`${adUnitBase}${adUnitSub}`}
                keys={posi}
                sizes={sizes}
                lazy={!!props.lazy}
                id={props.id}
              />
            ) : (
              <div className="gpt-container">
                <img src={props.static} alt="publicidad" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

AdvertismentWidget.propTypes = {
  position: PropTypes.string,
  sizesm: PropTypes.string,
  sizest: PropTypes.string,
  sizesd: PropTypes.string,
  static: PropTypes.string,
  lazy: PropTypes.string,
  id: PropTypes.string,
  stickyd: PropTypes.bool
  // adUnit: PropTypes.string
};

AdvertismentWidget.defaultProps = {
  static: undefined,
  id: undefined,
  lazy: undefined,
  position: undefined,
  sizesm: undefined,
  sizest: undefined,
  sizesd: undefined,
  stickyd: false
  // adUnit: ''
};

export default AdvertismentWidget;
